export default {
  // Textos específicos de Commune
  region: 'Región',
}
